module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/collegeFeatured2.webp";